import { gql } from 'graphql-request'

export const getUsersEvaluationAdmin = gql`
query GetEvaluation(
  $userId: ID!
  $month: Int!
  $year: Int!
){
    getEvaluation(
      userId: $userId
      month: $month
      year: $year
    ) {
      month_closed_admin
      month_closed_user
      comment
      user {
        full_name
        job_title
        status
        internal_number
        time_credit
        entry_date
      }
      holiday_overview {
        holiday_used_month
        holiday_total
        holiday_open
        holiday_pending
      }
      time_credit_overview {
        time_credit
        overtime_hours
        overtime_paid
        fixed_time 
        overtime_deduction
        remaining_time_credit
        info_time_credit
        info_remaining_time_credit
        time_credit_incl_future
        info_time_credit_incl_future
        future_overtime_reduction
        info_future_overtime_reduction
      }
      weekend_work_overview {
        weekend_emergency_service
        weekend_time_trackings
      }
      separate_payment_overview {
        night_hours
        emergency_service_payment 
        expenses_payment 
        info_emergency_service_payment
        info_expenses_payment
      }
      hour_overview {
        night_hours 
        sunday_hours 
        regular_hours 
        overtime_hours
        ist_sum_inkl_zuschlag
        month_working_hours 
        month_working_days 

        tracked_working_days
        sickdays 
        weekend_work_days
        
      }
    }
  }
`

export const getCars = gql`
  query GetCars($first: Int!, $page: Int!) {
    getCars(first: $first, page: $page) {
      data {
        id
        plate
        user {
          full_name
        }
        driveway
        driveway_enttro
      }
      paginatorInfo {
        currentPage
        lastPage
        total
        hasMorePages
      }
    }
  }
`;

export const getPayrollMonthOverview = gql`
query GetPayrollOfficeOverview(
  $month: Int!
  $year: Int!
){
    getPayrollOfficeOverview(
      month: $month
      year: $year
    ) {
      name 
      job_title 
      status
      internal_number 
      entry_date 
      month_hours
      payed_overtime_hours
      night_work 
      emergencs_service 
      expenses
      sunday_work 
      comment
    }
  }
`;

export const getAllUsers = gql`
  query AllUsers($page: Int!, $limit: Int!, $showInactive: Boolean, $search: String) {
    allUsers(page: $page, limit: $limit, showInactive: $showInactive, search: $search) {
      data {
        id
        last_name
        first_name
        full_name
        username
        entry_date
        internal_number
        status
        email
        job_title
        open_holidays
        hourly_wage
        daily_work_time
        time_credit
        exit_date
        fixed_time
        active
        holiday_total
        hasToken
        expenses
        datev_enabled
        emergency_service_enabled
        has_fixed_salary
        user_type {
          id
          type
        }
        work_schedule {
          monday_hours
          tuesday_hours
          wednesday_hours
          thursday_hours
          friday_hours
          saturday_hours
          sunday_hours
        }
      }
      paginatorInfo {
        currentPage
        lastPage
        total
      }
    }
  }
`;

export const getAdminRequests = gql`
  query GetAdminRequests(
    $search: String
    $approvedPage: Int
    $approvedLimit: Int
    $pendingPage: Int
    $pendingLimit: Int
    $from: Date
    $to: Date
    $type: String
    $approvalStatus: Int
    $user_id: ID
  ) {
    getAdminRequests(
      search: $search
      approvedPage: $approvedPage
      approvedLimit: $approvedLimit
      pendingPage: $pendingPage
      pendingLimit: $pendingLimit
      from: $from
      to: $to
      type: $type
      approvalStatus: $approvalStatus
      user_id: $user_id
    ) {
      approved {
        data {
          id
          user {
            id
            full_name
            email
          }
          type
          start_date
          end_date
          substitute
          status
          created_at 
          updated_at
        }
        paginatorInfo {
          currentPage
          lastPage
          perPage
          total
        }
      }
      pending {
        data {
          id
          user {
            id
            full_name
            email
          }
          type
          start_date
          end_date
          substitute
          token
          request_type
          edit_payload
          created_at 
          updated_at
        }
        paginatorInfo {
          currentPage
          lastPage
          perPage
          total
        }
      }
    }
  }
`;

export const getCloseMonthHours = gql`
  query GetCloseMonthHours(
    $month: Int!
    $year: Int!
    $userId: ID
  ) {
    getCloseMonthHours(
      month: $month
      year: $year
      userId: $userId
    ) {
      date
      total_hours
      emergency
      nightWork
      showAsHighlighted
      places {
        id
        client
        duration
        comment
        is_night_work
        is_emergency_service
      }
    }
  }   
`;

export const getUserTypes = gql`
  query GetUserTypes {
    getUserTypes {
      id
      type
    }
  }
`;

export const hasSickReportsForMonth = gql`
  query HasSickReports(
    $month: Int!, 
    $year: Int!) {
      hasSickReportsForMonth(
      month: $month, 
      year: $year)
  }
`;

export const getAdminDashboard = gql`
  query GetAdminDashboardForUser(
    $startdate: Date!,
    $enddate: Date!,
  ) {
    getAdminDashboard(
      startdate: $startdate
      enddate: $enddate
    ) {
      sickdays
      overtime_done
      overtime_payed
      overtime_taken
      overtime_adjust
      holiday_taken
      overtime_chart {
        user_id
        name
        overtime_done
        overtime_payed
        overtime_taken
        overtime_adjust
      }
      sickday_chart {
        user_id
        name
        sickdays
      }
      holiday_chart {
        user_id
        name
        holiday_taken
        holiday_open
      }
    }
  }
`;

export const getAdminTrackings = gql`
  query GetAdminTrackings(
  $start_date: Date!, 
  $end_date: Date!) {
    getAdminTrackings(
    start_date: $start_date, 
    end_date: $end_date) {
      id
      user_id
      employeeName
      type
      client
      date
      duration
      comment
    }
  }
`;

export const sendPushNotificationMutation = gql`
  mutation SendPushNotification($user_id: ID!, $title: String!, $body: String!) {
    sendPushNotification(user_id: $user_id, title: $title, body: $body)
  }
`;

export const sendReminderPushNotification = gql`
  mutation SendReminderPushNotification(
    $user_id: ID!, 
    $month: Int!, 
    $year: Int!) {
    sendReminderPushNotification(
      user_id: $user_id, 
      month: $month, 
      year: $year)
  }
`;

export const checkDatevData = gql`
  query CheckDatevData(
  $month: Int!, 
  $year: Int!) {
    existingDatevData(
    month: $month, 
    year: $year){
      id
      month
      path
      file_type
    }
  }
`;

export const getDatevDocumentsByUser = gql`
query GetDatevDocumentsByUser(
  $first: Int!, 
  $userId: Int, 
  $month: Int, 
  $year: Int) {
    datevPayrollDocuments(
    first: $first, 
    userId: $userId, 
    month: $month, 
    year: $year) {
      data {
        id
        month
        path
        user_id
        in_backend
        file_type
        user {
          full_name
        }
      }
      paginatorInfo {
        currentPage
        lastPage
        total
      }
    }
  }
`;

export const publishDatevData = gql`
  mutation PublishDatevData(
  $month: Int!, 
  $year: Int!) {
    publishDatevData(
    month: $month, 
    year: $year)
  }
`;

export const isPublished = gql`
  query IsPublished($month: Int!, $year: Int!) {
    isPublished(month: $month, year: $year)
  }
`;

export const getDocumentCategories = gql`
  query GetDocumentCategories {
    getDocumentCategories {
      id
      name
      validity_months
      has_expiry
    }
  }
`;
 
export const getDocumentsForUser = gql`
  query GetDocumentsForUser($user_id: ID!) {
    getDocumentsForUser(user_id: $user_id) {
      documentCategory {
        id
        name
        validity_months
        has_expiry
      }
      documents {
        id
        valid_from
        valid_until
        file_path
        created_at
      }
    }
  }
`;

export const createDocumentCategory = gql`
  mutation CreateDocumentCategory(
    $name: String!
    $validity_months: Int
    $has_expiry: Boolean
  ) {
    createDocumentCategory(
      name: $name
      validity_months: $validity_months
      has_expiry: $has_expiry
    ) {
      id
      name
      validity_months
      has_expiry
    }
  }
`;
 
export const updateDocumentCategory = gql`
  mutation UpdateDocumentCategory(
    $id: ID!
    $name: String
    $validity_months: Int
    $has_expiry: Boolean
  ) {
    updateDocumentCategory(
      id: $id
      name: $name
      validity_months: $validity_months
      has_expiry: $has_expiry
    ) {
      id
      name
      validity_months
      has_expiry
    }
  }
`;
 
export const deleteDocumentCategory = gql`
  mutation DeleteDocumentCategory($id: ID!) {
    deleteDocumentCategory(id: $id)
  }
`;

export const getWorkDaysBetween = gql`
  query GetWorkDaysBetween($userID: ID!, $start: Date!, $end: Date!) {
    getWorkDaysBetween(userID: $userID, start: $start, end: $end)
  }
`;

export const getDatevSettings = gql`
  query GetDatevSettings {
    datevSettings {
      id
      sandbox
      mandant_id
      client_id
      client_sandbox_id
      target_system
      document_types
      payroll_base_url
      payroll_sandbox_base_url
      exchange_base_url
      exchange_sandbox_base_url
      salary_type_id_amount
      salary_type_id_ueberstunden
      salary_type_id_notdienst
      salary_type_id_spesen
      salary_type_id_nachtarbeit
      salary_type_id_sonntagsarbeit
      created_at
      updated_at
      user_name
    }
  }
`

export const getDatevLogs = gql`
  query DatevLogs(
    $success: Boolean
    $method: String
    $statusCode: Int
    $search: String
    $first: Int
    $page: Int
  ) {
    datevLogs(
      success: $success
      method: $method
      statusCode: $statusCode
      search: $search
      first: $first
      page: $page
    ) {
      data {
        id
        request_at
        method
        url
        request_headers
        request_body
        response_at
        status_code
        status_message
        global_transaction_id
        cap_request_id
        response_headers
        response_body
        duration_ms
        success
        created_at
        updated_at
      }
      paginatorInfo {
        currentPage
        lastPage
        perPage
        total
      }
    }
  }
`

export const getDatevEmployeeValidationStatus = gql`
  query DatevEmployeeValidationStatus($month: Int!, $year: Int!) {
    datevEmployeeValidationStatus(month: $month, year: $year) {
      status
      error
      started_at
      finished_at
      results {
        internal_number
        exists_in_datev
        message
        checked_at
        user {
          id
          full_name
        }
      }
    }
  }
`

export const getValidToken = gql`
  query GetValidToken {
    getvalidToken
  }
`

export const getCalenderMonth = gql`
  query GetCalenderMonth(
    $userId: ID!
    $month: Int!
    $year: Int!
  ){
    getCalenderMonth(
      userId: $userId
      month: $month
      year: $year
    ) {
	    date
	    isEmergency 
	    highlighted 
	    trackings {
		    id
		    type
		    client
		    duration
		    comment
		    locked
	    }
	    
    }
  }
`;

export const getEmergencyServiceEnabled = gql`
  query GetEmergencyServiceEnabled($userId: ID) {
    getEmergencyServiceEnabled(userId: $userId)
  }
`;

export const getEmergencyServiceRate = gql`
  query GetEmergencyServiceRates {
    getEmergencyServiceRates {
      effective_date
      weekday_factor
      special_day_factor
      status
    }
  }
`;